import {importAsyncComponent, importRemoteComponent} from '@/utils/loadable';
import {withAfterDomReady} from '@/components/AfterDomReady';

const loadable = {
    // 异步加载组件
    loadAsync: (importFn: any, loadingComp?: any) => {
        return importAsyncComponent(importFn, loadingComp);
    },
    // 文档渲染完成后，再加载组件
    loadAfterDocReady: (importFn: any, loadingComp?: any) => {
        return withAfterDomReady(
            importAsyncComponent(importFn, loadingComp)
        );
    },
    // 远程加载组件
    loadRemote: (remoteUrl: string, compName: string, loadingComp?: any) => {
        return () => {
            return importRemoteComponent(remoteUrl, compName, loadingComp);
        };
    },
    // 文档渲染完成后，远程加载组件
    loadRemoteAfterDocReady: (remoteUrl: string, compName: string, loadingComp?: any) => {
        return () => {
            return withAfterDomReady(
                importRemoteComponent(remoteUrl, compName, loadingComp)
            );
        };
    },
};

export default loadable;
